export function isThemeQuery(query) {
  return 'businessTypes' in query;
}
export function isRawThemesRouteParams(params) {
  return 'businessType' in params || 'pageType' in params || 'pageFeature' in params;
}
export function isParsedThemesRouteParams(params) {
  return 'businessType' in params || 'pageType' in params || 'pageFeature' in params;
}